import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './SponsorsSection.css';

const SponsorsSection = () => {
  const [ref, inView] = useInView({
    threshold: 0.2,
    triggerOnce: true
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.8,
        ease: "easeOut"
      }
    }
  };

  // eslint-disable-next-line no-unused-vars
  const logoVariants = {
    hidden: { scale: 0.8, opacity: 0 },
    visible: {
      scale: 1,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  // Sponsors data with package tiers
  const sponsors = [
    // Gold package (5000)
    { 
      name: 'اكاديمية القاسمي الطيرة', 
      logo: '/qassimiacademyimage.jpeg', 
      tier: 'gold',
      package: 'Gold Package'
    },
    { 
      name: 'هات', 
      logo: '/haatlogo.png', 
      tier: 'gold',
      package: 'Gold Package'
    },
    { 
      name: 'مطبعة الطيرة 👑', 
      logo: '/tiraprintlogo.png', 
      tier: 'gold',
      package: 'Gold Package'
    },
    { 
      name: 'NJ Investments', 
      logo: '/NJ Investments.png', 
      tier: 'gold',
      package: 'Gold Package'
    },
    // Silver package (3500)
    { 
      name: 'شام كافيه', 
      logo: '/shamlogo.png', 
      tier: 'silver',
      package: 'Silver Package'
    },
    { 
      name: 'Boost', 
      logo: '/boost_logo.jpeg', 
      tier: 'silver',
      package: 'Silver Package'
    },
    { 
      name: 'Be pharm', 
      logo: '/be_logo.png', 
      tier: 'silver',
      package: 'Silver Package'
    },
    { 
      name: 'كمبيوتر الاقصى', 
      logo: '/aqsa computer.jpg', 
      tier: 'silver',
      package: 'Silver Package'
    },
    { 
      name: 'Mersin Auto Parts', 
      logo: '/Mersin.png', 
      tier: 'silver',
      package: 'Silver Package'
    },
    { 
      name: 'سمارة للتسويق والاتصال', 
      logo: '/Samara Marketing Communication.png', 
      tier: 'silver',
      package: 'Silver Package'
    },
    // Bronze package (2000)
    { 
      name: 'حلويات اخوان سمارة', 
      logo: '/Samara sweets.jpeg', 
      tier: 'bronze',
      package: 'Bronze Package'
    },
    { 
      name: 'مجوهرات الريان', 
      logo: '/rayan_jwelery.jpg', 
      tier: 'bronze',
      package: 'Bronze Package'
    },
    { 
      name: 'Restart', 
      logo: '/Restart - marketing and buiissness.png', 
      tier: 'bronze',
      package: 'Bronze Package'
    },
  ];

  return (
    <section className="sponsors-section section" id="sponsors">
      <div className="container">
        <motion.div 
          ref={ref}
          className="sponsors-content"
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          <motion.h2 className="section-title" variants={itemVariants}>
            رعاتنا الكرام
          </motion.h2>
          <motion.p className="sponsors-subtitle" variants={itemVariants}>
            شكراً للمنظمات التي تجعل هذا الحدث ممكناً!
          </motion.p>

          {sponsors.length > 0 ? (
            <>
              {/* Gold Sponsors Section */}
              <motion.div className="gold-sponsors-section" variants={itemVariants}>
                <h3 className="tier-title gold-title">الرعاة الذهبيون</h3>
                <div className="gold-sponsors-grid">
                  {sponsors.filter(sponsor => sponsor.tier === 'gold').map((sponsor, index) => (
                    <motion.div
                      key={index}
                      className="sponsor-card gold-sponsor-card"
                      variants={itemVariants}
                      whileHover={{ y: -8 }}
                    >
                      <div className={`sponsor-logo-circle sponsor-circle-gold ${sponsor.name === 'مطبعة الطيرة 👑' ? 'loyalty-special' : ''} ${sponsor.name === 'هات' ? 'haat-smoke-effect' : ''}`}>
                        <img src={sponsor.logo} alt={sponsor.name} className="sponsor-logo gold-logo" />
                      </div>
                      <h3 className="sponsor-name gold-name">{sponsor.name.replace(' 👑', '')}</h3>
                    </motion.div>
                  ))}
                </div>
              </motion.div>

              {/* Other Sponsors Section */}
              <motion.div className="other-sponsors-section" variants={itemVariants}>
                <h3 className="tier-title silver-title">رعاتنا الكرام</h3>
                <div className="other-sponsors-grid">
                  {sponsors.filter(sponsor => sponsor.tier !== 'gold').map((sponsor, index) => (
                    <motion.div
                      key={index}
                      className="sponsor-card silver-sponsor-card"
                      variants={itemVariants}
                      whileHover={{ y: -8 }}
                    >
                      <div className="sponsor-logo-circle sponsor-circle-silver">
                        <img src={sponsor.logo} alt={sponsor.name} className="sponsor-logo silver-logo" />
                      </div>
                      <h3 className="sponsor-name silver-name">{sponsor.name.replace(' 👑', '')}</h3>
                    </motion.div>
                  ))}
                </div>
              </motion.div>
            </>
          ) : (
            <motion.div className="sponsors-coming-soon" variants={itemVariants}>
              <div className="coming-soon-icon">🤝</div>
              <h3>الرعاة قريباً!</h3>
              <p>نحن نبحث بنشاط عن شركاء يشاركوننا رؤيتنا للتغيير الاجتماعي. مهتم بدعم هذا الحدث؟</p>
              <a href="mailto:contact@givehack.com" className="cta-button">كن راعياً</a>
            </motion.div>
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default SponsorsSection;
